<template>
  <div class="content">
    <div class="thehome">
      <span @click="topath('/')">{{ $t("header.home") }}</span>
      &nbsp;/&nbsp;<span @click="topath('/information')">{{
        $t("header.information")
      }}</span>
    </div>
    <div class="one">
      {{
        (locale == "zh" && state.detaillist?.title) ||
        state.detaillist?.en_title
      }}
    </div>
    <div v-if="!state.detaillist?.rich_content">
      <div class="detailcontent">
        {{
          (locale == "zh" && state.detaillist?.intro) ||
          state.detaillist?.en_intro
        }}
      </div>
      <div class="theimage">
        <img :src="state.detaillist?.full_cover" alt="" />
      </div>
      <div class="detailcontent" style="margin-top: 32px; margin-bottom: 100px">
        {{
          (locale == "zh" && state.detaillist?.content) ||
          state.detaillist?.en_content
        }}
      </div>
    </div>
    <div v-else>
      <div class="vease" v-html="state.detaillist?.rich_content"></div>
    </div>
    <div class="moreinfo">
      <div class="more">
        <div>
          {{ $t("header.More_information") }}
        </div>
        <div @click="topath('/information')">{{ $t("header.See_more") }}</div>
      </div>
      <div class="recommend">
        <div class="allinfo shang">
          <div class="left">
            <div>{{ $t("header.previous_posts") }}</div>
            <div @click="topath(`/information/${state.chatper.prev.id}`)">
              {{
                (locale == "zh" && state.chatper?.prev?.title) ||
                state.chatper?.prev?.en_title
              }}
            </div>
            <div>{{ state.chatper?.prev?.created_at.slice(0, 10) }}</div>
          </div>
          <div class="right">
            <img :src="state.chatper?.prev?.full_cover" alt="" />
          </div>
        </div>
        <div class="allinfo">
          <div class="left">
            <div>{{ $t("header.next_chapter") }}</div>
            <div @click="topath(`/information/${state.chatper?.next.id}`)">
              {{
                (locale == "zh" && state.chatper?.next?.title) ||
                state.chatper?.next?.en_title
              }}
            </div>
            <div>{{ state.chatper?.next?.created_at.slice(0, 10) }}</div>
          </div>
          <div class="right">
            <img :src="state.chatper?.next?.full_cover" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from "vue";
import { newsdetail } from "@/api/type";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const route = useRoute();
const router = useRouter();
const artworkId = Number(route.path.replace("/information/", ""));
newsdetail(artworkId).then((res) => {
  state.detaillist = res.data;
  state.chatper = res.more;
});
watch(
  () => router.currentRoute.value,
  () => {
    const artworkId = Number(route.path.replace("/information/", ""));
    newsdetail(artworkId).then((res) => {
      state.detaillist = res.data;
      state.chatper = res.more;
    });
  }
);
const state = reactive({
  detaillist: [],
  chatper: [],
});
const topath = (e) => {
  router.push(e);
};
</script>
<style lang="scss">
.vease {
  text-align: left;
  img {
    max-width: 100% !important;
    height: auto !important;
  }
}
</style>

<style lang="scss" scoped>
@import "@/sass/index.scss";

.content {
  max-width: 1176px;
  margin: 0 auto;
  .thehome {
    z-index: 0;
    position: relative;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .one {
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
  }
  .detailcontent {
    @include fontstyle(#333, 16px, 400, auto);
    line-height: 26px;
    text-align: left;
    white-space: pre-line;
    // margin-bottom: 32px;
  }
  .theimage {
    margin: 32px 0 32px 0;
    img {
      max-width: 50%;
    }
  }
  .moreinfo {
    .more {
      display: flex;
      justify-content: space-between;
      margin-bottom: 45px;
      :nth-child(1) {
        @include fontstyle(#333, 22px, 800, auto);
      }
      :nth-child(2) {
        @include fontstyle(#333, 14px, 400, pointer);
        text-decoration: underline;
      }
    }
    .recommend {
      margin-bottom: 100px;
      display: flex;
      justify-content: space-between;
      .shang {
        margin-right: 60px;
      }
      .allinfo {
        background: #eeeeee;
        flex: 1;
        display: flex;
        cursor: pointer;

        .left {
          padding: 20px 0px 20px 20px;
          text-align: left;
          margin-right: 20px;
          flex: 1;
          :nth-child(1) {
            @include fontstyle(#333, 14px, 400, pointer);
            margin-bottom: 8px;
          }
          :nth-child(2) {
            @include fontstyle(#333, 18px, 800, pointer);
            margin-bottom: 51px;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* 限制显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            white-space: normal; /* 防止文字溢出隐藏 */
            text-overflow: ellipsis;
          }
          :nth-child(3) {
            @include fontstyle(#666, 14px, 400, pointer);
          }
        }
        &:hover {
          .left {
            :nth-child(2) {
              @include fontstyle(#3657db, 18px, 800, pointer);
              text-decoration: underline;
            }
          }
        }
        .right {
          flex: 1;
          width: 272px;
          height: 176px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          img {
            // width: 100%;
            width: 400px;
            display: block;
            // height: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
    .one {
      @include fontstyle(#000, 28px, 800, auto);
    }
  }
}
@media screen and (max-width: 800px) {
  .content {
    .theimage {
      img {
        max-width: 100%;
      }
    }
    .recommend {
      display: flex;
      flex-direction: column;
      .shang {
        margin-right: 0px !important;
        margin-bottom: 60px;
      }
      .allinfo {
        flex-direction: column-reverse;
        .right {
          width: 100% !important;
          img {
          }
        }
      }
    }
  }
}
</style>
